// All 38 acronyms for the I GET TO Code Builder + Acronym Dictionary
// 18 original + 20 new = 38 total

const allAcronyms = [
  // ======================== ORIGINAL 18 ========================

  // --- CORE FRAMEWORK ---
  {
    code: "ACT NOW",
    title: "The 3 Stages of Transformation",
    category: "core",
    tier: "free",
    letters: [
      { letter: "A", word: "Awareness", definition: "Always the first step in transformation. You become aware that something isn't working. \"This does not work for me any longer.\" You start asking new questions." },
      { letter: "C", word: "Clarity", definition: "When the student is ready, the teacher appears. New conversations, books, workbooks, and education start to evolve in your life. Gaining clarity on the reclaimed self." },
      { letter: "T", word: "Tapped In", definition: "You begin integrating the new tools, establishing stronger boundaries, and updating your mindset. Rewiring begins. Not all at once — one repetition at a time, toward balance and strength." },
      { letter: "N.O.W.", word: "No Opportunity Wasted", definition: "Not tomorrow. Not someday. Now. There is so much more opportunity on the other side of fear. Regardless of the outcome, you gain wisdom — and that is liberating and powerful." },
    ],
  },

  // --- PERSONAL CODES ---
  {
    code: "SHIFT",
    title: "Personal Code of Conduct",
    category: "personal",
    tier: "free",
    letters: [
      { letter: "S", word: "Self-awareness", definition: "Recognizing your patterns, thoughts, and how you show up. The foundation of all change." },
      { letter: "H", word: "Honesty", definition: "Telling your truth, even when it's uncomfortable. Honesty with yourself comes first." },
      { letter: "I", word: "Integrity", definition: "Doing the right thing, even when no one is watching." },
      { letter: "F", word: "Forgiveness", definition: "Releasing resentment — giving up the hope that the past could have been any different." },
      { letter: "T", word: "Transformation", definition: "Embracing continuous growth and evolution. You are always becoming." },
    ],
  },
  {
    code: "BALANCE",
    title: "Personal Code of Conduct",
    category: "personal",
    tier: "paid",
    letters: [
      { letter: "B", word: "Boundaries", definition: "Protecting your peace and energy. \"I teach people how to treat me.\"" },
      { letter: "A", word: "Acceptance", definition: "Radical self-acceptance is the foundation of lasting change." },
      { letter: "L", word: "Love", definition: "Self-love is never found outside us — it is truly within." },
      { letter: "A", word: "Awareness", definition: "Staying conscious of your thoughts, speech, and emotional state." },
      { letter: "N", word: "Nurturing", definition: "Caring for mind, body, and spirit as a daily hygiene practice." },
      { letter: "C", word: "Compassion", definition: "Meeting yourself and others with compassionate curiosity, not judgment." },
      { letter: "E", word: "Empowerment", definition: "Reclaiming your inner authority and living by design, not by default." },
    ],
  },
  {
    code: "SOAR",
    title: "Personal Code of Conduct",
    category: "personal",
    tier: "free",
    letters: [
      { letter: "S", word: "Strength", definition: "Courage on the hard days — character is how you show up when tested, not on a typical day." },
      { letter: "O", word: "Optimism", definition: "Choosing to see every challenge as an opportunity to learn and gain wisdom." },
      { letter: "A", word: "Alignment", definition: "Living in harmony with your values, your truth, and your authentic self." },
      { letter: "R", word: "Relationships", definition: "Building connections that reflect and support who you are becoming." },
    ],
  },
  {
    code: "POWER",
    title: "Personal Code of Conduct",
    category: "personal",
    tier: "paid",
    letters: [
      { letter: "P", word: "Purpose", definition: "Knowing your why and living fully aligned with it." },
      { letter: "O", word: "Openness", definition: "Releasing the need for control; trusting divine timing and alignment." },
      { letter: "W", word: "Wisdom", definition: "Knowledge gained through experience, transformed into lasting insight." },
      { letter: "E", word: "Empathy", definition: "Understanding and sharing the emotions of others." },
      { letter: "R", word: "Resilience", definition: "Bouncing back. It is not failure — it is a redirect." },
    ],
  },
  {
    code: "GROW",
    title: "Release Old Ways",
    category: "personal",
    tier: "free",
    letters: [
      { letter: "G", word: "Get", definition: "" },
      { letter: "R", word: "Rid", definition: "" },
      { letter: "O", word: "Of", definition: "" },
      { letter: "W", word: "Old Ways", definition: "Release what no longer serves you to create space for who you are becoming. Version 2.0 is waiting." },
    ],
  },
  {
    code: "BRAVING",
    title: "The Anatomy of Trust",
    category: "personal",
    tier: "paid",
    letters: [
      { letter: "B", word: "Boundaries", definition: "Making clear what's okay and what's not okay, and why. You respect your boundaries, and when you're not clear about what's okay and what's not okay, you ask." },
      { letter: "R", word: "Reliability", definition: "You do what you say you'll do. You are aware of your competencies and limitations so you don't overpromise and underdeliver." },
      { letter: "A", word: "Accountability", definition: "You own your mistakes, apologize, and make amends. You don't blame others or make excuses." },
      { letter: "V", word: "Vault", definition: "You don't share information or experiences that are not yours to share. I need to know that my confidences are kept." },
      { letter: "I", word: "Integrity", definition: "Choosing courage over comfort; choosing what's right over what's fun, fast, or easy; practicing your values, not just professing them." },
      { letter: "N", word: "Nonjudgment", definition: "I can ask for what I need, and you can ask for what you need. We can talk about how we feel without judgment." },
      { letter: "G", word: "Generosity", definition: "Extending the most generous interpretation possible to the intentions, words, and actions of others." },
    ],
  },

  // --- TOOLS & VALUES ---
  {
    code: "THANKFUL",
    title: "Daily Gratitude Ritual",
    category: "tools",
    tier: "free",
    letters: [
      { letter: "T", word: "Tolerant", definition: "Of my life's lessons & compassion for self and others as I move through change." },
      { letter: "H", word: "Helpful", definition: "And gracious to everyone with no agenda." },
      { letter: "A", word: "Aligned", definition: "To my unique ability." },
      { letter: "N", word: "New", definition: "Life to create from a place of JOY & my authentic self." },
      { letter: "K", word: "Knowledge", definition: "To consistently maintain my personal growth." },
      { letter: "F", word: "Fun", definition: "Make time for fun. I will create JOY in my life." },
      { letter: "U", word: "Useful", definition: "To be of service and create a purposeful, productive contribution." },
      { letter: "L", word: "Love", definition: "Be consciously loving & to allow them to love me." },
    ],
  },

  // --- FAMILY CODES ---
  {
    code: "TEAM",
    title: "Family Code of Conduct",
    category: "family",
    tier: "paid",
    letters: [
      { letter: "T", word: "Trust", definition: "We build a home where truth is safe and trust is earned through consistency." },
      { letter: "E", word: "Empathy", definition: "We seek to understand before we seek to be understood." },
      { letter: "A", word: "Active Listening", definition: "We listen with presence — not just waiting for our turn to speak." },
      { letter: "M", word: "Mutual Respect", definition: "Every voice in this family matters. Every person is worthy of dignity." },
    ],
  },
  {
    code: "HEART",
    title: "Family Code of Conduct",
    category: "family",
    tier: "paid",
    letters: [
      { letter: "H", word: "Honor", definition: "We honor each other's individuality, journey, and growth." },
      { letter: "E", word: "Empathy", definition: "We lead with compassion in every conversation." },
      { letter: "A", word: "Accountability", definition: "We own our mistakes and model responsibility." },
      { letter: "R", word: "Respect", definition: "We respect boundaries, differences, and each other's space." },
      { letter: "T", word: "Togetherness", definition: "We show up for each other — in celebration and in struggle." },
    ],
  },
  {
    code: "CARE",
    title: "Family Code of Conduct",
    category: "family",
    tier: "paid",
    letters: [
      { letter: "C", word: "Communication", definition: "We speak openly, honestly, and with kindness." },
      { letter: "A", word: "Action-Oriented", definition: "We don't just talk about change — we live it." },
      { letter: "R", word: "Responsibility", definition: "We each take ownership of our role in the family." },
      { letter: "E", word: "Empathy", definition: "We meet each other where we are, without judgment." },
    ],
  },
  {
    code: "BRAVE",
    title: "Family Code of Conduct",
    category: "family",
    tier: "paid",
    letters: [
      { letter: "B", word: "Boundaries", definition: "We respect each other's limits and teach our children to honor theirs." },
      { letter: "R", word: "Respect", definition: "We model the respect we want to receive." },
      { letter: "A", word: "Acceptance", definition: "We accept each other fully — the messy parts too." },
      { letter: "V", word: "Voice", definition: "Everyone in this family has a voice that deserves to be heard." },
      { letter: "E", word: "Empathy", definition: "We choose understanding over being right." },
    ],
  },
  {
    code: "SPARK",
    title: "Family Code of Conduct",
    category: "family",
    tier: "paid",
    letters: [
      { letter: "S", word: "Support", definition: "We are each other's biggest champions." },
      { letter: "P", word: "Positivity", definition: "We choose to focus on what's going right, not just what's going wrong." },
      { letter: "A", word: "Authenticity", definition: "We are real with each other — no masks at home." },
      { letter: "R", word: "Resilience", definition: "When life gets hard, we get through it together." },
      { letter: "K", word: "Kindness", definition: "Kindness is the default. Always." },
    ],
  },

  // --- BUSINESS CODES ---
  {
    code: "INTEGRITY",
    title: "Business Code of Conduct",
    category: "business",
    tier: "paid",
    letters: [
      { letter: "I", word: "Innovation", definition: "We embrace creativity and find new ways to serve." },
      { letter: "N", word: "Nurturing Culture", definition: "We build environments where people thrive." },
      { letter: "T", word: "Transparency", definition: "We communicate openly — even when it's hard." },
      { letter: "E", word: "Excellence", definition: "We hold ourselves to a standard of quality in everything." },
      { letter: "G", word: "Growth", definition: "We invest in our own development and our team's." },
      { letter: "R", word: "Responsibility", definition: "We own our impact — on people, community, and planet." },
      { letter: "I", word: "Impact", definition: "We measure success by the lives we change." },
      { letter: "T", word: "Teamwork", definition: "We achieve more together than alone." },
      { letter: "Y", word: "Yield Results", definition: "We translate intention into action and action into impact." },
    ],
  },
  {
    code: "FOCUS",
    title: "Business Code of Conduct",
    category: "business",
    tier: "paid",
    letters: [
      { letter: "F", word: "Fairness", definition: "We treat every person with equity and respect." },
      { letter: "O", word: "Opportunity", definition: "We create opportunities for growth, not just profit." },
      { letter: "C", word: "Customer-Centricity", definition: "Everything starts with the people we serve." },
      { letter: "U", word: "Unity", definition: "We win as a team and support each other's success." },
      { letter: "S", word: "Success", definition: "We define success by impact, integrity, and joy." },
    ],
  },
  {
    code: "GREAT",
    title: "Business Code of Conduct",
    category: "business",
    tier: "paid",
    letters: [
      { letter: "G", word: "Guidance", definition: "We lead with mentorship, not authority." },
      { letter: "R", word: "Respect", definition: "Respect is the foundation of every interaction." },
      { letter: "E", word: "Ethics", definition: "We do the right thing, even when no one is watching." },
      { letter: "A", word: "Accountability", definition: "We own outcomes — good and bad." },
      { letter: "T", word: "Trust", definition: "We build trust through consistency and transparency." },
    ],
  },
  {
    code: "VALUE",
    title: "Business Code of Conduct",
    category: "business",
    tier: "paid",
    letters: [
      { letter: "V", word: "Vision", definition: "We lead with a clear, inspiring vision of what's possible." },
      { letter: "A", word: "Accountability", definition: "We hold ourselves to the standards we set." },
      { letter: "L", word: "Leadership", definition: "Leadership is service, not status." },
      { letter: "U", word: "Understanding", definition: "We seek to understand before we seek to solve." },
      { letter: "E", word: "Empathy", definition: "We build businesses that care about the humans behind the numbers." },
    ],
  },

  // ======================== 20 NEW ACRONYMS ========================

  // --- NEW PERSONAL CODES ---
  {
    code: "GRACE",
    title: "Personal Code of Conduct",
    category: "personal",
    tier: "free",
    letters: [
      { letter: "G", word: "Gratitude", definition: "I start every day acknowledging what I have — not what I lack. Gratitude is the lens that changes everything I see." },
      { letter: "R", word: "Resilience", definition: "I have survived every hard day so far. My survival rate is 100%. That's not luck — that's me." },
      { letter: "A", word: "Acceptance", definition: "I accept where I am without judging it. This is my starting point, not my destination." },
      { letter: "C", word: "Compassion", definition: "I meet myself with the same kindness I give to everyone else. I GET TO be gentle with me." },
      { letter: "E", word: "Evolution", definition: "I am not who I was last year. I am not yet who I will become. I honor both versions." },
    ],
  },
  {
    code: "TRUST",
    title: "Personal Code of Conduct",
    category: "personal",
    tier: "paid",
    letters: [
      { letter: "T", word: "Truth", definition: "I tell myself the truth — about what I feel, what I need, and what I deserve. The truth doesn't always feel good. It always sets you free." },
      { letter: "R", word: "Release", definition: "I release what I cannot control. I release who I used to be to make room for who I am becoming." },
      { letter: "U", word: "Understanding", definition: "I seek to understand myself — my triggers, my patterns, my needs — before I try to change." },
      { letter: "S", word: "Self-love", definition: "Self-love is not found outside of me. It is truly within. I GET TO love myself first." },
      { letter: "T", word: "Transformation", definition: "I commit to the process. Healing is not an event — it is a practice. I honor the time it takes." },
    ],
  },
  {
    code: "WORTH",
    title: "Personal Code of Conduct",
    category: "personal",
    tier: "paid",
    letters: [
      { letter: "W", word: "Wholeness", definition: "I am already whole. I am not here to be fixed — I am here to be uncovered. Beneath the layers of what the world told me to be is who I actually am." },
      { letter: "O", word: "Ownership", definition: "I own my story — the beautiful parts and the painful parts. I did then what I knew how to do. Now I know better, I do better." },
      { letter: "R", word: "Respect", definition: "I teach people how to treat me by how I treat myself. My standard is the standard." },
      { letter: "T", word: "Truth", definition: "My truth may make others uncomfortable. That is not my burden to carry. My truth is my freedom." },
      { letter: "H", word: "Honor", definition: "I honor my journey — every wrong turn, every breakdown, every breakthrough. It all brought me here." },
    ],
  },
  {
    code: "FAITH",
    title: "Personal Code of Conduct",
    category: "personal",
    tier: "paid",
    letters: [
      { letter: "F", word: "Fearless", definition: "Not the absence of fear — but the decision to move through it anyway. I GET TO feel afraid and act." },
      { letter: "A", word: "Aligned", definition: "I align my actions with my values. When they match, I feel peace. When they don't, I course-correct." },
      { letter: "I", word: "Intentional", definition: "I live by design, not by default. Every choice is an opportunity to choose who I am becoming." },
      { letter: "T", word: "Trusting", definition: "I trust divine timing. I trust the process. I trust that what is meant for me will not miss me." },
      { letter: "H", word: "Healing", definition: "Healing is not linear. Some days I move forward. Some days I rest. Both are healing." },
    ],
  },
  {
    code: "DREAM",
    title: "Personal Code of Conduct",
    category: "personal",
    tier: "paid",
    letters: [
      { letter: "D", word: "Dare", definition: "I dare to want more. Not more stuff — more meaning, more alignment, more of what makes me feel alive." },
      { letter: "R", word: "Reimagine", definition: "I GET TO reimagine my life at any age, any stage, any chapter. It is never too late to redesign." },
      { letter: "E", word: "Evolve", definition: "I am not stuck. I am evolving. Every breakdown is a breakthrough in disguise." },
      { letter: "A", word: "Attract", definition: "When I align with who I truly am, I attract what is truly meant for me. Energy doesn't lie." },
      { letter: "M", word: "Manifest", definition: "I create my reality one thought, one word, one choice at a time. The vision is already in motion." },
    ],
  },
  {
    code: "PEACE",
    title: "Personal Code of Conduct",
    category: "personal",
    tier: "free",
    letters: [
      { letter: "P", word: "Presence", definition: "I choose to be HERE — not replaying the past, not rehearsing the future. Right now is enough." },
      { letter: "E", word: "Ease", definition: "I release the belief that life has to be hard to be meaningful. I GET TO let things be easy." },
      { letter: "A", word: "Acceptance", definition: "I accept what I cannot change. I change what I can. I trust myself to know the difference." },
      { letter: "C", word: "Calm", definition: "Calm is a practice, not a personality trait. I choose it again and again, especially when it's hardest." },
      { letter: "E", word: "Empowerment", definition: "My peace is not dependent on other people's behavior. I GET TO protect it. It belongs to me." },
    ],
  },

  // --- NEW WELLNESS / HEALING CODES ---
  {
    code: "WHOLE",
    title: "Wellness & Healing Code",
    category: "wellness",
    tier: "paid",
    letters: [
      { letter: "W", word: "Wellness", definition: "Wellness is a daily practice, not a destination. Mind, body, spirit — all three deserve my attention." },
      { letter: "H", word: "Healing", definition: "I am not broken. I am healing. Healing is not about going back to who I was — it's about becoming who I am." },
      { letter: "O", word: "Openness", definition: "I stay open to new tools, new perspectives, new ways of feeling better. The teacher appears when I'm ready." },
      { letter: "L", word: "Love", definition: "Loving me is loving you is loving us. It all starts with how I treat myself." },
      { letter: "E", word: "Evolution", definition: "My wellness journey evolves as I do. What worked last year may not work today. I stay curious." },
    ],
  },
  {
    code: "RENEW",
    title: "Wellness & Healing Code",
    category: "wellness",
    tier: "paid",
    letters: [
      { letter: "R", word: "Release", definition: "I release the weight that was never mine to carry. Other people's emotions are not my responsibility." },
      { letter: "E", word: "Embrace", definition: "I embrace ALL of my feelings — the comfortable and the uncomfortable. They are all valid messengers." },
      { letter: "N", word: "Nourish", definition: "I nourish my body, my mind, and my spirit with what gives life — not what drains it." },
      { letter: "E", word: "Evolve", definition: "Every ending is a beginning I haven't recognized yet. I GET TO start fresh. Every morning is a reset." },
      { letter: "W", word: "Wisdom", definition: "My experiences — even the painful ones — have given me wisdom. I am not damaged by my past. I am informed by it." },
    ],
  },
  {
    code: "LIGHT",
    title: "Wellness & Healing Code",
    category: "wellness",
    tier: "paid",
    letters: [
      { letter: "L", word: "Love", definition: "Love is the highest frequency. When I choose love — for myself, for others, for my life — everything shifts." },
      { letter: "I", word: "Intention", definition: "I set one intention each morning. Not a to-do list — an intention for how I want to FEEL today." },
      { letter: "G", word: "Gratitude", definition: "Gratitude rewires my brain. Every \"I GET TO\" is neuroplasticity in action." },
      { letter: "H", word: "Healing", definition: "I give myself permission to heal at my own pace. There is no deadline on becoming whole." },
      { letter: "T", word: "Truth", definition: "I shine light on what I've been hiding from. The truth is not always comfortable — but it's always free." },
    ],
  },
  {
    code: "BREATHE",
    title: "Wellness & Healing Code",
    category: "wellness",
    tier: "free",
    letters: [
      { letter: "B", word: "Be", definition: "Before I do anything — I just BE. I exist. That is enough." },
      { letter: "R", word: "Release", definition: "With every exhale, I release what doesn't serve me." },
      { letter: "E", word: "Embrace", definition: "With every inhale, I embrace what gives me life." },
      { letter: "A", word: "Awareness", definition: "I notice my breath. I notice my body. I notice this moment. That IS the practice." },
      { letter: "T", word: "Trust", definition: "I trust my body to breathe. I trust my path to unfold. I trust myself to handle what comes." },
      { letter: "H", word: "Heal", definition: "Every conscious breath is a micro-healing. My nervous system is listening." },
      { letter: "E", word: "Evolve", definition: "I am not the same person who took the last breath. I am always becoming." },
    ],
  },
  {
    code: "CALM",
    title: "Wellness & Healing Code",
    category: "wellness",
    tier: "paid",
    letters: [
      { letter: "C", word: "Compassion", definition: "I meet my anxiety with compassion, not criticism. It's my nervous system trying to protect me." },
      { letter: "A", word: "Awareness", definition: "I notice the feeling without becoming the feeling. I am not my anxiety. I am the person observing it." },
      { letter: "L", word: "Let Go", definition: "I let go of what I cannot control. I let go of tomorrow's problems. My only job right now is this moment." },
      { letter: "M", word: "Mindfulness", definition: "I return to my senses — what I see, touch, hear, smell, taste. The present moment is always safe." },
    ],
  },

  // --- NEW EMPOWERMENT CODES ---
  {
    code: "THRIVE",
    title: "Empowerment Code",
    category: "empowerment",
    tier: "paid",
    letters: [
      { letter: "T", word: "Truth", definition: "I speak my truth even when my voice shakes. My truth is my power." },
      { letter: "H", word: "Healing", definition: "I am not just surviving — I am healing. And healing people do extraordinary things." },
      { letter: "R", word: "Resilience", definition: "I bend but I do not break. Every challenge builds a muscle I didn't know I had." },
      { letter: "I", word: "Intention", definition: "I live with purpose. I choose my thoughts. I design my days. Nothing about my life is accidental." },
      { letter: "V", word: "Vision", definition: "I see a future that excites me. I move toward it daily — baby steps, micro steps, but always forward." },
      { letter: "E", word: "Empowerment", definition: "I take my power back. Not from anyone else — from the version of me who gave it away. She's done." },
    ],
  },
  {
    code: "FIERCE",
    title: "Empowerment Code",
    category: "empowerment",
    tier: "paid",
    letters: [
      { letter: "F", word: "Fearless", definition: "I do not wait for fear to leave. I invite it along for the ride — and drive anyway." },
      { letter: "I", word: "Intentional", definition: "I am deliberate about my energy, my time, and who gets access to both." },
      { letter: "E", word: "Empowered", definition: "Nobody gave me permission to be powerful. I gave it to myself. I GET TO." },
      { letter: "R", word: "Resilient", definition: "I have been through things that would break some people. I am still here. Still standing. Still growing." },
      { letter: "C", word: "Courageous", definition: "Courage is not the absence of fear. It's one more step when everything inside says stop." },
      { letter: "E", word: "Evolving", definition: "I am not finished. I am not meant to be. I am a masterpiece AND a work in progress." },
    ],
  },
  {
    code: "RISE",
    title: "Empowerment Code",
    category: "empowerment",
    tier: "free",
    letters: [
      { letter: "R", word: "Resilience", definition: "Every time I fall, I learn something I couldn't learn standing up. The fall is part of the rise." },
      { letter: "I", word: "Identity", definition: "I am not what happened to me. I am what I choose to become. I GET TO define me." },
      { letter: "S", word: "Strength", definition: "My strength is not measured by what I can carry — it's measured by what I can put down." },
      { letter: "E", word: "Evolution", definition: "I rise by evolving, not by forcing. Growth happens when I stop fighting and start flowing." },
    ],
  },
  {
    code: "VOICE",
    title: "Empowerment Code",
    category: "empowerment",
    tier: "paid",
    letters: [
      { letter: "V", word: "Vulnerability", definition: "My vulnerability is not weakness. It is the birthplace of connection, creativity, and courage." },
      { letter: "O", word: "Ownership", definition: "I own my story. Every chapter. Including the ones I wish I could rewrite. They made me who I am." },
      { letter: "I", word: "Intention", definition: "I speak with intention. My words create my reality — so I choose them carefully." },
      { letter: "C", word: "Courage", definition: "I GET TO speak up, even when my voice shakes. My words matter. My perspective matters. I matter." },
      { letter: "E", word: "Expression", definition: "I express who I am — unapologetically, authentically, fully. The world needs the real me, not the performance." },
    ],
  },
  {
    code: "FREE",
    title: "Empowerment Code",
    category: "empowerment",
    tier: "paid",
    letters: [
      { letter: "F", word: "Forgiveness", definition: "I forgive — not because they deserve it, but because I deserve peace. Forgiveness is giving up the hope that the past could have been any different." },
      { letter: "R", word: "Release", definition: "I release the need to be understood by everyone. My peace does not require their approval." },
      { letter: "E", word: "Empowerment", definition: "I reclaim every piece of myself I gave away to keep someone else comfortable. I GET TO be whole again." },
      { letter: "E", word: "Evolution", definition: "Freedom is not a destination. It is a daily choice to live as the truest version of myself." },
    ],
  },
  {
    code: "QUEEN",
    title: "Empowerment Code",
    category: "empowerment",
    tier: "paid",
    letters: [
      { letter: "Q", word: "Quiet Confidence", definition: "I don't need to be the loudest in the room. My presence speaks. My energy enters before I do." },
      { letter: "U", word: "Unapologetic", definition: "I am done apologizing for who I am, what I need, and how much space I take up. I GET TO exist fully." },
      { letter: "E", word: "Empowered", definition: "My crown was never given to me by someone else — and it cannot be taken by someone else." },
      { letter: "E", word: "Evolving", definition: "A queen never stops growing. She outgrows rooms, relationships, and versions of herself — and she is not sorry about it." },
      { letter: "N", word: "Nurturing", definition: "I nurture myself with the same fierce love I give everyone else. My cup is not optional." },
    ],
  },

  // --- NEW LIFE DESIGN CODES ---
  {
    code: "ALIGN",
    title: "Life Design Code",
    category: "personal",
    tier: "paid",
    letters: [
      { letter: "A", word: "Authenticity", definition: "I stop performing who the world wants me to be. I GET TO be exactly who I am." },
      { letter: "L", word: "Love", definition: "I lead with love — for myself first, then for others. Self-love is the foundation, not the reward." },
      { letter: "I", word: "Intention", definition: "I design my days instead of reacting to them. Intentional living is the ultimate power move." },
      { letter: "G", word: "Growth", definition: "I commit to growth — not perfection. Progress over performance. Always." },
      { letter: "N", word: "Now", definition: "The only moment I have power over is this one. I GET TO be present in it." },
    ],
  },
  {
    code: "SACRED",
    title: "Life Design Code",
    category: "personal",
    tier: "paid",
    letters: [
      { letter: "S", word: "Self", definition: "My relationship with myself is the longest relationship I will ever have. I GET TO make it a good one." },
      { letter: "A", word: "Awareness", definition: "I pay attention to what my body, mind, and spirit are telling me. They always know before my brain does." },
      { letter: "C", word: "Courage", definition: "I choose courage over comfort. Growth lives on the other side of what scares me." },
      { letter: "R", word: "Reclaim", definition: "I reclaim every part of myself I abandoned to fit in. She's still in there. She's been waiting." },
      { letter: "E", word: "Evolve", definition: "I am a sacred work in progress. Every version of me has served a purpose. This version is just getting started." },
      { letter: "D", word: "Divine", definition: "I am guided. I am supported. I am held — even when I can't see it. The Divine Team is always with me." },
    ],
  },
];

export default allAcronyms;
